/** Whether a set has a logged numeric RPE (empty field = no RPE). */
export function setHasRpeLogged(set) {
  if (!set) return false;
  const v = set.rpe;
  if (v === undefined || v === null || v === "") return false;
  const n = Number(v);
  return !Number.isNaN(n);
}

export function exerciseHasAnyRpe(exercise) {
  if (!exercise) return false;
  for (const s of exercise.sets || []) {
    if (setHasRpeLogged(s)) return true;
  }
  for (const sub of exercise.subExercises || []) {
    for (const s of sub.sets || []) {
      if (setHasRpeLogged(s)) return true;
    }
  }
  if (Array.isArray(exercise.circuit)) {
    for (const round of exercise.circuit) {
      if (!Array.isArray(round)) continue;
      for (const sub of round) {
        for (const s of sub?.sets || []) {
          if (setHasRpeLogged(s)) return true;
        }
      }
    }
  }
  return false;
}

export function workoutHasAnyRpe(workout) {
  if (!workout?.exercises?.length) return false;
  return workout.exercises.some(exerciseHasAnyRpe);
}
